<template>
  <div>
    <b-button
      v-b-toggle="'list-invisible-training'"
      class="m-1"
      variant="info">Liste des leçons</b-button>
    <b-collapse id="list-invisible-training">
      <b-row
        align-h="end"
        class="mb-2">
        <b-col
          class="m-0 p-0 text-right"
          cols="3"
          align-self="end">
          <b-button
            v-b-modal.modal-lesson-add
            variant="success">Ajouter une nouvelle leçon</b-button>
          <b-modal
            id="modal-lesson-add"
            title="Ajouter une nouvelle leçon"
            scrollable
            hide-footer>
            <form-training
              :offers="offers"
              :needs="needs"
              :usages="usages"
              :documents="documents"
              @sendForm="receiveUpdate"/>
          </b-modal>
        </b-col>
      </b-row>
      <b-row v-if="loading">
        <b-col class="text-center">
          <b-spinner
            small
            variant="primary"
            type="grow"
            label="Spinning"/>
          <b-spinner
            small
            variant="primary"
            type="grow"
            label="Spinning"/>
          <b-spinner
            small
            variant="primary"
            type="grow"
            label="Spinning"/>
        </b-col>
      </b-row>
      <b-row v-else>
        <!--div v-if="(modules == null
        && preset != null
        && preset.length === 0)
        || (preset == null && modules != null && modules.length === 0)">
          <b-row class="align-center text-center">
            <b-col><i>Aucune liste de modules</i></b-col>
          </b-row>
        </div-->
        <!--div v-else-->
        <b-col class="m-0 p-0">
          <b-form-group
            label="Filtrer"
            label-cols-sm="3"
            label-align-sm="left"
            label-size="sm"
            label-for="filterInput">
            <b-input-group size="sm">
              <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Taper pour rechercher une leçon de formation"/>
              <b-input-group-append>
                <b-button
                  :disabled="!filter"
                  @click="filter = ''">Effacer</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-table
        :fields="fields"
        :items="trainingLessons"
        :filter="filter"
        :filter-included-fields="filterOn"
        :key="reRender"
        small
        responsive="sm">
        <template #cell(fle_id)="row">
          <b-col>{{ row.item.fle_id }}</b-col>
        </template>
        <template #cell(fle_label)="row">
          <b-col>{{ row.item.fle_label }}</b-col>
        </template>
        <template #cell(fle_description)="row">
          <b-col>{{ row.item.fle_description }}</b-col>
        </template>
        <template #cell(fle_is_enable)="row">
          <b-col class="badge-sizing">
            <b-badge
              v-if="row.item.fle_is_enable"
              sm
              variant="success">&#x2714;</b-badge>
            <b-badge
              v-else
              sm
              variant="danger">&#x10102;</b-badge>
          </b-col>
        </template>
        <template #cell(needs)="row">
          <b-col
            v-for="need in row.item.needs"
            :key="need.fne_id+'need'+row.item.fle_id"
            class="mt-2 badge-sizing">
            <b-badge :style="{ 'background-color': need.fne_color }">{{ need.fne_label }}</b-badge>
          </b-col>
        </template>
        <template #cell(usages)="row">
          <b-col
            v-for="usage in row.item.usages"
            :key="usage.fus_id+'usage'+row.item.fle_id"
            class="mt-2 badge-sizing">
            <b-badge :style="{ 'background-color': usage.fus_color }">{{ usage.fus_label }}</b-badge>
          </b-col>
        </template>
        <template #cell(offers)="row">
          <b-col
            v-for="offer in row.item.offers"
            :key="offer.off_id+'offer'+row.item.fle_id"
            class="mt-2 badge-sizing">
            <b-badge variant="secondary">{{ offer.off_name }}</b-badge>
          </b-col>
        </template>
        <template #cell(documents)="row">
          <b-col
            v-for="document in row.item.documents"
            :key="document.doc_id+'document'+row.item.fle_id"
            class="mt-2 badge-sizing">
            <b-badge variant="secondary">{{ document.doc_type }}</b-badge>
            <b-badge variant="light">{{ document.doc_name }}</b-badge>
          </b-col>
        </template>
        <template #cell(update)="row">
          <b-row>
            <b-col class="mt-1">
              <b-button
                v-b-modal="'modal-update-training-'+ row.item.fle_id"
                size="sm"
                variant="primary">Modifier</b-button>
            </b-col>
            <b-modal
              :id="'modal-update-training-'+ row.item.fle_id"
              title="Modifier une leçon"
              scrollable
              hide-footer>
              <form-training
                :id="row.item.fle_id"
                :lesson="row.item"
                :offers="offers"
                :needs="needs"
                :usages="usages"
                :documents="documents"
                @sendForm="receiveUpdate"/>
            </b-modal>
            <b-col class="mt-1">
              <b-button
                :variant="row.item.fle_is_enable ? 'warning' : 'success'"
                size="sm"
                @click="changeLessonStatus(row.item)">{{ row.item.fle_is_enable ? 'Désactiver' : 'Activer' }}</b-button>
            </b-col>
            <b-col class="mt-1">
              <b-button
                variant="danger"
                size="sm"
                @click="deleteLesson(row.item)">Supprimer</b-button>
            </b-col>
          </b-row>
        </template>
      </b-table>
    </b-collapse>
  </div>
</template>

<script>

import FormTraining from '../forms/FormTraining.vue';
import { compareArraysAndState } from '../../misc/utils';
import { operationBus } from '../../main';

export default {
  name: 'ListTraining',
  components: { FormTraining },
  data() {
    return {
      title: 'List Training',
      fields: [
        {
          fle_id: {
            label: 'Id',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          fle_label: {
            label: 'Nom',
            sortable: true,
            tdClass: 'align-middle',
            filterByFormatted: true,
          },
        },
        {
          fle_description: {
            label: 'Description',
            sortable: false,
            tdClass: 'align-middle',
          },
        },
        {
          fle_is_enable: {
            label: 'Statut',
            sortable: true,
            tdClass: 'align-middle',
            filterByFormatted: true,
          },
        },
        {
          needs: {
            label: 'Besoins',
            sortable: true,
            tdClass: 'align-middle',
            filterByFormatted: true,
          },
        },
        {
          usages: {
            label: 'Usages',
            sortable: true,
            tdClass: 'align-middle',
            filterByFormatted: true,
          },
        },
        {
          offers: {
            label: 'Offres',
            sortable: true,
            tdClass: 'align-middle',
            filterByFormatted: true,
          },
        },
        {
          documents: {
            label: 'Documents',
            sortable: true,
            tdClass: 'align-middle text-left',
            filterByFormatted: true,
          },
        },
        {
          update: {
            label: 'Actions',
            sortable: false,
            tdClass: 'align-middle',
          },
        },
      ],
      filter: null,
      filterOn: [],
      loading: true,
      trainingLessons: [],
      offers: [],
      needs: [],
      usages: [],
      documents: [],
      reRender: 0,
      changeType: null,
      formUpdate: null,
      moduleToUpdate: null,
    };
  },
  mounted() {
    this.getParams();
    this.getTrainingLessons();
  },
  methods: {
    loadTrainingLessons(trainingLessons) {
      this.loading = false;
      this.trainingLessons = trainingLessons;
      this.reRender += 1;
    },
    getTrainingLessons() {
      this.$store.dispatch('establishments/getTrainingLessons',
        { })
        .then(response => this.loadTrainingLessons(JSON.parse(JSON.stringify(response.data))));
    },
    loadOffers(offers) {
      this.offers = offers;
      this.reRender += 1;
    },
    loadNeeds(needs) {
      this.needs = needs;
      this.reRender += 1;
    },
    loadUsages(usages) {
      this.usages = usages;
      this.reRender += 1;
    },
    loadDocuments(documents) {
      this.documents = documents;
      this.reRender += 1;
    },
    getParams() {
      this.$store.dispatch('contracts/getAllOffers',
        { })
        .then(response => this.loadOffers(JSON.parse(JSON.stringify(response.data))));
      this.$store.dispatch('contracts/getAllNeeds',
        { })
        .then(response => this.loadNeeds(JSON.parse(JSON.stringify(response.data))));
      this.$store.dispatch('contracts/getAllUsages',
        { })
        .then(response => this.loadUsages(JSON.parse(JSON.stringify(response.data))));
      this.$store.dispatch('contracts/getAllTrainingDocuments',
        { })
        .then(response => this.loadDocuments(JSON.parse(JSON.stringify(response.data))));
    },
    receiveUpdate(form, lesson) {
      console.log(`receiveUpdate ${form}`, lesson);
      const jsonForm = JSON.parse(form);
      const trainId = jsonForm.train_id;
      const existingOffers = lesson && lesson.offers ? lesson.offers.map(o => o.off_id) : [];
      const existingNeeds = lesson && lesson.needs ? lesson.needs.map(o => o.fne_id) : [];
      const existingUsages = lesson && lesson.usages ? lesson.usages.map(o => o.fus_id) : [];
      const existingDocuments = lesson && lesson.documents ? lesson.documents.map(o => o.doc_ass_id) : [];
      const offers = compareArraysAndState(existingOffers, jsonForm.train_offers, 'off_id');
      const needs = compareArraysAndState(existingNeeds, jsonForm.train_needs, 'fne_id');
      const usages = compareArraysAndState(existingUsages, jsonForm.train_usages, 'fus_id');
      const documents = compareArraysAndState(existingDocuments, jsonForm.train_documents, 'doc_ass_id');

      jsonForm.train_offers = offers;
      jsonForm.train_needs = needs;
      jsonForm.train_usages = usages;
      jsonForm.train_documents = documents;
      jsonForm.train_is_enable = lesson ? lesson.fle_is_enable : false;

      this.$store.dispatch('establishments/setTrainingLesson', jsonForm)
        .then(() => {
          this.getTrainingLessons();
          if (documents) {
            this.$store.dispatch('contracts/getAllTrainingDocuments',
              { })
              .then(response => this.loadDocuments(JSON.parse(JSON.stringify(response.data))));
          }
        });
      if (lesson) {
        this.$root.$emit('bv::hide::modal', `modal-update-training-${trainId}`);
      } else {
        this.$root.$emit('bv::hide::modal', 'modal-lesson-add');
      }
    },
    changeLessonStatus(lesson) {
      const form = {
        train_id: lesson.fle_id,
        train_name: lesson.fle_label,
        train_description: lesson.fle_description ? lesson.fle_description : '',
        train_is_enable: !lesson.fle_is_enable,
        train_offers: [],
        train_needs: [],
        train_usages: [],
        train_documents: [],
      };
      this.$store.dispatch('establishments/setTrainingLesson', form)
        .then(() => this.getTrainingLessons());
    },
    deleteLesson(item) {
      const operation = {
        id: `train${item.fle_id}`, // TODO : Generate id
        cancel: false,
        action: `la suppression de la leçon : ${item.fle_label}`,
        request: 'establishments/deleteTrainingLesson',
        params: { train_id: item.fle_id },
      };
      operationBus.$emit('operationAdded', operation);
      operationBus.$on('operationFinished', () => {
        this.getTrainingLessons();
      });
    },
  },
};
/* TODO : - Changement de params : Faire une liste de paramètres possibles
*  TODO : - Changement de nom : on insère si le thème n'existe pas
* */
</script>
<style>
  .badge-sizing {
    font-size: 1rem;
  }
  #list-invisible-training {
    font-size: 0.75em;
  }
</style>
